export default __webpack_public_path__ + "static/media/zeeshan.a959b910.webp";